export const MONTH_AND_DAY_DATE_FORMAT = 'MM/DD'
export const DATE_FORMAT = 'MM/DD/YYYY'
export const SHORT_DATE_FORMAT = 'M/D/YYYY'
export const DATE_FORMAT_FOR_SERVER = 'YYYY-MM-DD'
export const YEAR_FORMAT = 'YYYY'

export const TIME_FORMAT = 'h:mm A'
export const TIME_FORMAT_FOR_SERVER = 'HH:mm:ss'
export const US_TIME_FORMAT_REPORT = 'hh:mm a'
export const US_TIME_FORMAT = 'h:mm a'

export const DATE_TIME_US_FORMAT_REPORT = `${DATE_FORMAT} ${US_TIME_FORMAT_REPORT}`
export const DATE_TIME_FORMAT_FOR_SERVER = `${DATE_FORMAT_FOR_SERVER} ${TIME_FORMAT_FOR_SERVER}`
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`

export const UUID_REGEXP =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'

export const PHONE_NUMBER_REGEXP = /^[0-9]\d{2}-\d{3}-\d{4}$/
export const PHONE_NUMBER_REGEXP_NORMALIZED = /^\d{10}$/

export const PATIENT_ID_MASK_INPUT = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

export const REFERRAL_ID_MASK_INPUT = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

export const MASK_INPUT_PHONE = [
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

export const PASSWORD_REGEXP =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*()+\-<>]).{8,}$/
export const ZIP_CODE_PATTERN = /\b\d{5}\b/

export const FILE_NAME_WITH_DOUBLE_QUOTES_REGEXP =
  /(?<=filename=")(.*)(csv|pdf|xls|xlsx|png|jpg|jpeg|gif|webp|txt|json|xml|zip|rar|7z|doc|docx|ppt|pptx|mp3|mp4|wav|mov|avi)/gi

export const FILE_NAME_WITHOUT_DOUBLE_QUOTES_REGEXP =
  /(?<=filename=)(.*)(csv|pdf|xls|xlsx|png|jpg|jpeg|gif|webp|txt|json|xml|zip|rar|7z|doc|docx|ppt|pptx|mp3|mp4|wav|mov|avi)/gi

// Email validation regular expression
// eslint-disable-next-line prefer-regex-literals
export const EMAIL_VALIDATION_REGEXP = new RegExp(
  '(?=(ˆ[a-z0-9_-]+\\.)*[a-z0-9_-]+@[a-z0-9_-]+(\\.[a-z0-9_-]+)*\\.[a-z]{2,10}$).{2,127}',
  'i'
)

// numbers
export const SIX_DIGITS_REGEXP = /^(0|\d{1,6})$/

export const CELL_TIME_FORMAT = 'h:mm:ss A'
